export const ROOT_DOMAIN = process.env.REACT_APP_ROOT_DOMAIN;
export const API_URL = process.env.REACT_APP_API_URL;
export const APP_URL = process.env.REACT_APP_URL;
export const API_SITE_URL = process.env.REACT_APP_API_SITE_URL;
export const S3_CLIENT_URL = process.env.REACT_APP_S3_CLIENT